import { render, staticRenderFns } from "./card.vue?vue&type=template&id=245e79a2&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"
import style0 from "./card.less?vue&type=style&index=0&id=245e79a2&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e79a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245e79a2')) {
      api.createRecord('245e79a2', component.options)
    } else {
      api.reload('245e79a2', component.options)
    }
    module.hot.accept("./card.vue?vue&type=template&id=245e79a2&scoped=true", function () {
      api.rerender('245e79a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/card.vue"
export default component.exports